// First-run tutorial pager (5 steps). Shown once; reachable again from Settings / Help.
import React, { useState } from 'react';
import { Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTranslation } from 'react-i18next';
import { useNav } from '../navigation';
import { useSettings } from '../store/settings';
import BrandLogo from '../components/BrandLogo';
import Icon, { type IconName } from '../components/Icon';
import { Body, Button, Caption, ProgressBar, Row } from '../components/ui';
import { font, spacing, usePalette } from '../theme';

const STEPS: { icon: IconName; key: 's1' | 's2' | 's3' | 's4' | 's5' }[] = [
  { icon: 'country', key: 's1' },
  { icon: 'camera', key: 's2' },
  { icon: 'timer', key: 's3' },
  { icon: 'planner', key: 's4' },
  { icon: 'library', key: 's5' },
];

export default function OnboardingScreen() {
  const { t } = useTranslation();
  const nav = useNav();
  const p = usePalette();
  const insets = useSafeAreaInsets();
  const set = useSettings(s => s.set);
  const [i, setI] = useState(0);
  const step = STEPS[i];
  const last = i === STEPS.length - 1;
  const finish = () => {
    set({ onboardingSeen: true });
    if (nav.canGoBack()) nav.goBack();
    else nav.reset({ index: 0, routes: [{ name: 'Tabs' }] });
  };
  return (
    <View style={{ flex: 1, backgroundColor: p.background, paddingTop: insets.top + spacing.l, paddingBottom: insets.bottom + spacing.l, paddingHorizontal: spacing.xl, gap: spacing.xl }}>
      <Text style={{ fontSize: font.title2, fontWeight: '800', color: p.text }}>{t('onboarding.title')}</Text>
      <ProgressBar value={(i + 1) / STEPS.length} color={p.tint} />
      <Caption>{t('onboarding.stepOf', { n: i + 1, total: STEPS.length })}</Caption>
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', gap: spacing.l }}>
        <View style={{ backgroundColor: `${p.tint}1A`, borderRadius: 999, padding: spacing.xxl }}>
          {i === 0 ? <BrandLogo size={140} /> : <Icon name={step.icon} size={72} color={p.tint} strokeWidth={1.5} />}
        </View>
        <Text style={{ fontSize: font.title, fontWeight: '800', color: p.text, textAlign: 'center' }}>{t(`onboarding.${step.key}Title`)}</Text>
        <Body secondary style={{ textAlign: 'center', fontSize: 18 }}>{t(`onboarding.${step.key}Body`)}</Body>
      </View>
      <Row style={{ flexWrap: 'nowrap' }} gap={spacing.m}>
        <Button label={t('onboarding.back')} variant="secondary" icon="back" disabled={i === 0} onPress={() => setI(x => x - 1)} style={{ flex: 1 }} iconOnly />
        <Button label={last ? t('onboarding.start') : t('onboarding.next')} icon={last ? 'check' : 'forward'} onPress={() => (last ? finish() : setI(x => x + 1))} style={{ flex: 1 }} iconOnly />
      </Row>
    </View>
  );
}
